import { createVanIconComponent } from "./van"

const ShoppingCart = createVanIconComponent("shopping-cart")
export default ShoppingCart
